import { Input as BaseInput, InputProps } from "baseui/input";
import { Theme, useTheme } from "@src/common/components/ThemeProvider/ThemeProvider";

export interface PercentInputProps extends InputProps {
  percent: number;
  setPercent: (percent: number) => void;
}

const PercentInput: React.FC<PercentInputProps> = ({
  percent,
  setPercent,
  onChange,
  ...props
}) => {
  const { effectiveTheme } = useTheme();
  return (
    <BaseInput
      startEnhancer="%"
      min={0}
      max={100}
      value={`${percent.toFixed(2)}`}
      onChange={(event) => {
        if (onChange) {
          onChange(event);
        }
        let num: number = 0.0;
        if (event.target.value) {
          const numValue = event.target.value.replace(/[^\d-]|(?!^)-/g, "");
          num = numValue === "" ? 0.0 : Number(numValue);
        }
        setPercent(num / 100);
      }}
      {...props}
      overrides={{
        ...props.overrides,
        Input: {
          ...props.overrides?.Input,
          style: {
            backgroundColor: effectiveTheme === Theme.DARK ? "rgb(31 41 55)" : "rgb(249 250 251)",
            colorScheme: effectiveTheme === Theme.DARK ? "dark" : "light",
            ...props.overrides?.Input?.style,
          },
        },
      }}
    />
  );
};

export default PercentInput;
